module.exports = __webpack_public_path__ + "bw.svg?5f11a0beed3ff05c3accc5df7e42fd66";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/bw.svg
// module id = 1279
// module chunks = 0